import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';


const TRAFFIC_SOURCE_MAP: Record<string, number> = {
  'edm-newsletter': 123,
  'google-ads': 121,
  'social-ads': 122,
  'organic': 126,
};

@Injectable({
  providedIn: 'root',
})
export class TrafficSourceService {
  private readonly COOKIE_KEY = 'wk_foundusid';
  // 30 hari — sinkron dengan Google Ads default click attribution window
  private readonly COOKIE_DAYS = 30;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  initTrafficSource(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Baca URL secara synchronous — hindari timing issue dari queryParamMap async
    const params = new URLSearchParams(window.location.search);
    const sourceId = Number(params.get('sourceid') || 0);

    // sourceid dari URL selalu menang — overwrite cookie yang ada
    if (sourceId > 0) {
      this.setCookie(this.COOKIE_KEY, String(sourceId), this.COOKIE_DAYS);
      console.log('Traffic source captured via sourceid param, foundusid:', sourceId);
      return;
    }

    // Jika cookie sudah ada (dari kunjungan sebelumnya dalam 30 hari), jangan timpa
    if (this.getCookie(this.COOKIE_KEY)) return;

    // const utmMedium = (params.get('utm_medium') || '').toLowerCase().trim();
    // const gclid = params.get('gclid') || '';
    // const gadSource = params.get('gad_source') || '';
    // const fbclid = params.get('fbclid') || '';
    // const ttclid = params.get('ttclid') || '';
    // const liFatId = params.get('li_fat_id') || '';
    // const epik = params.get('epik') || '';
    // const referrer = document.referrer.toLowerCase();
    // const foundusid = this.resolve(utmMedium, gclid, gadSource, fbclid, ttclid, liFatId, epik, referrer);
    // if (foundusid > 0) {
    //   this.setCookie(this.COOKIE_KEY, String(foundusid), this.COOKIE_DAYS);
    //   console.log('Traffic source captured, foundusid:', foundusid);
    // }
  }

  getFoundUsId(): number {
    if (!isPlatformBrowser(this.platformId)) return 0;
    return Number(this.getCookie(this.COOKIE_KEY) || 0);
  }

  clearFoundUsId(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    document.cookie = `${this.COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    console.log('foundusid cleared from cookie.');
  }

  private setCookie(name: string, value: string, days: number): void {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  private getCookie(name: string): string {
    const nameEQ = name + '=';
    for (let c of document.cookie.split(';')) {
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return '';
  }

  private resolve(medium: string, gclid: string, gadSource: string, fbclid: string, ttclid: string, liFatId: string, epik: string, referrer: string): number {
    // 1. EDM / Newsletter
    if (['email', 'edm', 'newsletter'].includes(medium)) {
      return TRAFFIC_SOURCE_MAP['edm-newsletter'];
    }

    // 2. Google Ads (paid search) - via utm_medium or Google click params
    if (['cpc', 'ppc', 'paid', 'paidsearch', 'paid_search'].includes(medium) || gclid || gadSource) {
      return TRAFFIC_SOURCE_MAP['google-ads'];
    }

    // 3. Social Ads (paid social)
    const paidSocialMediums = ['paid_social', 'paidsocial', 'social_paid'];
    if (paidSocialMediums.includes(medium) || fbclid || ttclid || liFatId || epik) {
      return TRAFFIC_SOURCE_MAP['social-ads'];
    }

    // 4. Organic - ada UTM
    // if (medium === 'organic') {
    //   return TRAFFIC_SOURCE_MAP['organic'];
    // }

    // // 4b. Organic - datang dari search engine tanpa paid UTM
    // const organicReferrers = ['google.', 'bing.com', 'yahoo.', 'duckduckgo.com', 'ecosia.org'];
    // if (!medium && organicReferrers.some((r) => referrer.includes(r))) {
    //   return TRAFFIC_SOURCE_MAP['organic'];
    // }

    return 0;
  }
}
